"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RailCarBulkCoupledDrive = function RailCarBulkCoupledDrive(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.78",
    height: "24",
    viewBox: "0 0 54.78 24",
    fill: "#93c01f"
  }, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "25.17 13.5 25.17 7.19 30.42 10.35 25.17 13.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.58,15.2H22.49V8.83l4-5.17V.8a.8.8,0,0,0-.81-.8H0V1.57H24.92V3.12l-4,5.18v6.9H12.8V9.67a.79.79,0,1,0-1.57,0V15.2H0v4.63H7.62a.78.78,0,0,0,.65-.36,4.2,4.2,0,0,0-.06.62,3.91,3.91,0,1,0,5.94-3.33H18a3.91,3.91,0,1,0,4.05,0h4.51a.78.78,0,1,0,0-1.56ZM8.42,18.87V16.76H10.1A3.92,3.92,0,0,0,8.42,18.87Zm6.06,1.22a2.36,2.36,0,1,1-2.36-2.35A2.36,2.36,0,0,1,14.48,20.09Zm7.91,0A2.35,2.35,0,1,1,20,17.74,2.35,2.35,0,0,1,22.39,20.09Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.39,16a.79.79,0,0,0,.81.78h4.51a3.92,3.92,0,1,0,4,0h3.87a3.91,3.91,0,1,0,5.94,3.33,4.2,4.2,0,0,0-.06-.62.78.78,0,0,0,.65.36h7.62V15.2H43.55V9.67a.79.79,0,1,0-1.57,0V15.2H33.86V8.3l-4-5.18V1.57H54.78V0H29.1a.8.8,0,0,0-.81.8V3.66l4,5.17V15.2H28.2A.79.79,0,0,0,27.39,16Zm17.29.78h1.68v2.11A3.92,3.92,0,0,0,44.68,16.76Zm-2,1a2.35,2.35,0,1,1-2.36,2.35A2.35,2.35,0,0,1,42.66,17.74Zm-7.92,0a2.35,2.35,0,1,1-2.35,2.35A2.35,2.35,0,0,1,34.74,17.74Z"
  }));
};

var _default = RailCarBulkCoupledDrive;
exports["default"] = _default;